import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagerHeaderComponent } from './manager-header.component';
import { IonicModule } from '@ionic/angular';
import { PosManagerMenuModule } from 'src/app/components/pos-manager/menu/pos-manager.module';

@NgModule({
  declarations: [ManagerHeaderComponent],
  imports: [CommonModule, IonicModule, PosManagerMenuModule],
  exports: [ManagerHeaderComponent]
})
export class ManagerHeaderComponentModule {}
